<template>
  <!-- Phase 2 - Payment Alert Banner for Hospital Dashboard (#25) -->
  <b-alert
    v-if="showAlert"
    show
    :variant="alertVariant"
    class="d-flex align-items-center mb-3"
  >
    <i class="mdi mdi-alert-circle-outline me-2 font-size-18"></i>
    <div class="flex-grow-1">
      <strong>{{ alertTitle }}</strong>
      <p class="mb-0">{{ alertMessage }}</p>
    </div>
    <b-button
      v-if="showPayButton"
      variant="primary"
      size="sm"
      @click="$emit('pay')"
      >Pay Now</b-button
    >
  </b-alert>
</template>

<script>
export default {
  props: {
    paymentReferenceNo: {
      type: String,
      default: "",
    },
    hospitalStatus: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    isPaid() {
      return !!this.paymentReferenceNo;
    },
    isExpired() {
      return String(this.hospitalStatus) === "3";
    },
    showAlert() {
      return !this.isPaid || this.isExpired;
    },
    showPayButton() {
      return !this.isPaid;
    },
    alertVariant() {
      if (!this.isPaid) return "warning";
      if (this.isExpired) return "danger";
      return "info";
    },
    alertTitle() {
      if (!this.isPaid) return "Annual Registration Fee (ARF) Pending";
      if (this.isExpired) return "Hospital Registration Expired";
      return "";
    },
    alertMessage() {
      if (!this.isPaid) {
        return "Your hospital's Annual Registration Fee of Rs.20,000 is pending. Please complete the payment to continue operations.";
      }
      if (this.isExpired) {
        return "Your hospital registration has expired. Please renew to continue transplant operations.";
      }
      return "";
    },
  },
};
</script>
